import { Conversation } from '../models/conversation.model';

/** The record (application / borrower / lead / agent) a conversation is shown under and its texts are attributed to. */
export interface ConversationTargetContext {
  applicationId?: number | null;
  borrowerId?: number | null;
  leadId?: number | null;
  agentId?: number | null;
}

/**
 * Attributes the conversation a user opened from a record's SMS bubble to that record: the chat window sends texts
 * and the details pane picks templates with the conversation's ids, and a conversation already linked to another
 * record (an earlier loan of the same borrower, say) would otherwise attribute them there. Applied to the row and
 * its grouped sub-conversations, in the UI only; the persisted link is left as it is. A context without any id
 * (the dialpad passes one) is ignored so it cannot clear an existing link.
 * Returns true when the context was applied.
 */
export function applyTargetPersonContext(
  conversation: Conversation | null | undefined,
  context: ConversationTargetContext | null | undefined,
): boolean {
  if (!conversation || !context) {
    return false;
  }
  if (!context.applicationId && !context.borrowerId && !context.leadId && !context.agentId) {
    return false;
  }
  const targets = [conversation, ...(conversation.conversations ?? [])];
  for (const target of targets) {
    target.applicationId = context.applicationId || null;
    target.borrowerId = context.borrowerId || null;
    target.leadId = context.leadId || null;
    target.agentId = context.agentId || null;
  }
  return true;
}
